import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import Theme from './theme'
import Store from './store'
import Router from './router'

const router = Router()
const store = Store(router, window.__INITIAL_STATE__)
const rootEl = document.querySelector('#root')

let render = () => {
  const RootAppComponent = require('./root').default
  ReactDOM.render(
    <Provider store={ store }>
      <Theme>
        <RootAppComponent
          store={ store }
          router={ router }
        />
      </Theme>
    </Provider>,
    rootEl
  )
}

if(module.hot) {
  module.hot.accept('./root', () => {
    setTimeout(render)
  })
}

render()
